export default [
  {
    path: "/saldo",
    name: "balance",
    component: () => import("../views/balance/Index.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      viewContainer: true,
      breadcrumbs: ["balance"]
    }
  }
];
